import React, { Component } from 'react';

class Input extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isFocused: false
        }
    }

    onFocus = () => {
        this.setState({
            isFocused: true
        });
    }

    // onBlur = () => {
    //     this.setState({
    //         isFocused: false
    //     });
    // }

    render() {
        var classes = ["input-div"];

        if (this.state.isFocused) {
            classes.push('open');
        }

        return (
            <div className={classes.join(' ')}>
                <span style={this.props.style} >{this.props.title}</span>
                <input
                    type={this.props.type}
                    onFocus={this.onFocus}
                    // onBlur={this.onBlur}
                    onChange={this.props.onChange}
                    className={this.props.className}
                    placeholder={this.props.placeholder}
                    name={this.props.name}
                    value={this.props.value}
                    ref={this.props.ref}
                    autoFocus = {this.props.autofocus}
                    onBlur={this.props.onBlur}
                />
                {this.props.children}
            </div>
        );
    }
}


export default Input;